module.exports = __webpack_public_path__ + "static/media/logo.8098988f.jpg";